/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the String length of a given `shortLabel` is invalid
 * @export
 * @class I18nInvalidShortLabelLengthError
 * @extends {Error}
 */
export class I18nInvalidShortLabelLengthError extends Error {
  /**
   * Creates an instance of I18nInvalidShortLabelLengthError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidShortLabelLengthError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidShortLabelLengthError`;
  }
}

/**
 * Called when the String length of a given `shortLabel` is invalid
 * @param {string} shortLabel The invalid `shortLabel`
 * @returns {never} never
 */
const throwI18nInvalidShortLabelLengthError = (shortLabel) => {
  throw new I18nInvalidShortLabelLengthError(
    stripIndent(`
    Expected "shortLabel" to have a "length" greater than "0";
    Got: "${shortLabel}"
    `),
  );
};

export default throwI18nInvalidShortLabelLengthError;
